var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.381 4.712a.8.8 0 0 0 .537.192.74.74 0 0 0 .523-.192.67.67 0 0 0 .22-.51.63.63 0 0 0-.22-.495.7.7 0 0 0-.523-.207.76.76 0 0 0-.537.207.65.65 0 0 0-.206.495q0 .303.206.51M7.546 10.77H6.5v.73h3.03v-.73h-.978V6.09H6.514v.73h1.032v3.951z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-.696 0A7.304 7.304 0 1 1 .696 8a7.304 7.304 0 0 1 14.608 0",
  clipRule: "evenodd"
})));
export default SvgInfoIcon;